var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoticeSlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.333 2a2 2 0 100 4h2.001V4a2.001 2.001 0 00-2.001-2m0 5.333H4a2 2 0 000 4h5.333a2 2 0 100-4z",
    fill: "#36C5F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 9.333a2 2 0 00-4 0v2h2a2 2 0 002-2zm-5.333 0V4a2 2 0 00-4 0v5.333a2 2 0 104 0z",
    fill: "#2EB67D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.666 21.998a2 2 0 100-3.999h-2v2c0 1.102.895 1.998 2 2zm0-5.334H20a2 2 0 000-4h-5.333a2 2 0 000 4z",
    fill: "#ECB22E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14.668a2 2 0 004 0v-2H4a2 2 0 00-2 2zm5.333 0V20a2 2 0 104 0V14.67a2 2 0 00-4-.001z",
    fill: "#E01E5A"
  })));
}

export default SvgNoticeSlack;